import { render, staticRenderFns } from "./BuyingPage.vue?vue&type=template&id=b839bdde&scoped=true&"
import script from "./BuyingPage.vue?vue&type=script&lang=js&"
export * from "./BuyingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b839bdde",
  null
  
)

export default component.exports